<template>
  <div>

    <v-tabs v-if="!readonly" v-model="tab" density="compact" class="mb-4">
      <v-tab value="view" :text="$t('titles.view')" />
      <v-tab v-if="!readonly" value="edit" :text="$t('titles.edit')" />
    </v-tabs>

    <v-tabs-window v-model="tab">

      <v-tabs-window-item value="view">
        <div class="compiled" v-html="compiledHtml" />
      </v-tabs-window-item>

      <v-tabs-window-item value="edit">
        <o-textarea v-model="model" />
        <v-alert color="info" icon="$alert" density="compact" class="mb-4">
          <p>Never put passwords or other sensitive data in this field.</p>
        </v-alert>
        <p>You can use Markdown in this field. <a href="https://www.markdownguide.org/getting-started/" target="_blank" rel="external">Help with Markdown</a></p>
      </v-tabs-window-item>

    </v-tabs-window>

  </div>
</template>

<script setup>

import { computed, ref } from 'vue'
import { refDebounced } from '@vueuse/core'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import OTextarea from './OTextarea.vue'

defineProps({

  readonly: {
    type: Boolean,
    default: true,
  },

})

const model = defineModel()
const debouncedModel = refDebounced(model, 1000) // so we don't recompile on every keystroke

const tab = ref('view')

const compiledHtml = computed(() => {
  if (!debouncedModel.value) {
    return ''
  }
  const compiled = marked(debouncedModel.value)
  // @ts-ignore (marked's typings say that compiled could be a Promise or a string - but we know that it's a string, because we didn't pass async: true)
  return DOMPurify.sanitize(compiled)
})

</script>

<style lang="scss">

.compiled {

  h1, h2, h3, h4, h5, h6 {
    color: inherit;
    font-size: 120%; // calm down a little
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  ul {
    list-style-type: disc;
    margin-bottom: 1rem;
    li {
      margin-left: 1rem;
    }
  }

  ol {
    list-style-type: decimal;
    margin-bottom: 1rem;
    li {
      margin-left: 1rem;
    }
  }

}

</style>
